import {
	API_GET_ALL_VALIDATION_PAUSED_REASON,
	API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON,
	API_ADMIN_GET_VALIDATION_PAUSED_REASON,
	ADMIN_INIT_NEW_VALIDATION_PAUSED_REASON,
	ADMIN_RESET_FOCUS_VALIDATION_PAUSED_REASON,
	API_ADMIN_POST_VALIDATION_PAUSED_REASON,
	API_ADMIN_PATCH_VALIDATION_PAUSED_REASON,
	API_ADMIN_DELETE_VALIDATION_PAUSED_REASON,
} from 'actions/validationPausedReason';

export function getAllValidationPausedReasons() {
	return {
		type: API_GET_ALL_VALIDATION_PAUSED_REASON,
		payload: {
			request: {
				url: `/validationPausedReasons`
			}
		}
	};
}

export function adminGetAllValidationPausedReasons() {
	return {
		type: API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON,
		payload: {
			request: {
				url: `/admin/validationPausedReasons`
			}
		}
	};
}

export function adminGetValidationPausedReason(validationPausedReason) {
	return {
		type: API_ADMIN_GET_VALIDATION_PAUSED_REASON,
		payload: {
			request: {
				url: `/admin/validationPausedReasons/${validationPausedReason.id}`
			}
		}
	};
}

export function adminPostValidationPausedReason(validationPausedReason) {
	return {
		type: API_ADMIN_POST_VALIDATION_PAUSED_REASON,
		payload: {
			request: {
				url: `/admin/validationPausedReasons`,
				method: 'POST',
				data: validationPausedReason
			}
		}
	};
}

export function adminPatchValidationPausedReason(validationPausedReason) {
	return {
		type: API_ADMIN_PATCH_VALIDATION_PAUSED_REASON,
		payload: {
			request: {
				url: `/admin/validationPausedReasons/${validationPausedReason.id}`,
				method: 'PATCH',
				data: validationPausedReason
			}
		}
	};
}

export function adminDeleteValidationPausedReason(validationPausedReason) {
	return {
		type: API_ADMIN_DELETE_VALIDATION_PAUSED_REASON,
		payload: {
			request: {
				url: `/admin/validationPausedReasons/${validationPausedReason.id}`,
				method: 'DELETE'
			}
		}
	};
}

export function initNewValidationPausedReason() {
	return {
		type: ADMIN_INIT_NEW_VALIDATION_PAUSED_REASON
	};
}

export function resetFocusValidationPausedReason() {
	return {
		type: ADMIN_RESET_FOCUS_VALIDATION_PAUSED_REASON
	};
}
